import { render, staticRenderFns } from "./agricult_product_meun.vue?vue&type=template&id=ca62b8a2&"
import script from "./agricult_product_meun.vue?vue&type=script&lang=js&"
export * from "./agricult_product_meun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports